import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingSouthParkCharacterGeneratorConfig } from '@/data/landingConfig/landingSouthParkCharacterGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_SouthParkCharacterGenerator } from './schemaObject';

interface Props {}
const SouthParkCharacterGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_SouthParkCharacterGenerator} />
			<LandingTemplate
				data={landingSouthParkCharacterGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default SouthParkCharacterGenerator;
